const MONGO_ID_REG = /^(?=[a-f\d]{24}$)(\d+[a-f]|[a-f]+\d)/i;

export default function isMongoId(str: any): boolean {
    return !!(str && MONGO_ID_REG.test(String(str)));
}
